import { render, staticRenderFns } from "./Traderlist.vue?vue&type=template&id=6fb352f0"
import script from "./Traderlist.vue?vue&type=script&lang=js"
export * from "./Traderlist.vue?vue&type=script&lang=js"
import style0 from "./Traderlist.vue?vue&type=style&index=0&id=6fb352f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports